export const complaintsPage = {
  heading: 'complaints-heading',
  sectionBody: 'complaints-sectionBody',
  sectionHeading: 'complaints-heading',
};
